import { deserialize } from 'serializr';
import { AxiosError } from 'axios';
import axiosInstance from '../../interceptor/axiosInstance';
import { ApiRoutes } from '../../routes/routeConstants/apiRoutes';
import { NotificationTypes } from '../../enums/notificationTypes';
import Notification from '../../shared/components/Notification/index';
import { myProfileServiceMessages } from './myProfile.constants';
import {
  EditProfilePayload,
  EditProfileResponse,
  ProfileResponse,
  SetProfilePasswordPayload,
  SetProfilePasswordResponse,
  SubscriptionActionResponse,
} from '../../models/profile.model';

export const getAxiosErrorMessage = (error: unknown): string | undefined => {
  const axiosError = error as AxiosError<{ error?: string; message?: string }>;
  return axiosError?.response?.data?.error || axiosError?.response?.data?.message || axiosError?.message;
};

export const notifyMyProfileService = (type: NotificationTypes, message?: string) => {
  Notification({
    message: message || myProfileServiceMessages.DEFAULT_ERROR,
    description: '',
    type,
  });
};

export const fetchProfile = async (): Promise<ProfileResponse> => {
  try {
    const { data } = await axiosInstance.get(ApiRoutes.PROFILE);
    return deserialize(ProfileResponse, data);
  } catch (error) {
    notifyMyProfileService(NotificationTypes.ERROR, myProfileServiceMessages.GET_PROFILE_ERROR);
    throw error;
  }
};

export const saveProfile = async (payload: EditProfilePayload): Promise<EditProfileResponse> => {
  const { data } = await axiosInstance.put(ApiRoutes.PROFILE, payload);
  return data;
};

export const saveProfilePassword = async (payload: SetProfilePasswordPayload): Promise<SetProfilePasswordResponse> => {
  const { data } = await axiosInstance.put(ApiRoutes.PROFILE_PASSWORD, payload);
  return data;
};

export const requestSubscriptionRenewal = async (): Promise<SubscriptionActionResponse> => {
  const { data } = await axiosInstance.post(ApiRoutes.PROFILE_SUBSCRIPTION_RENEW, {});
  return data;
};

export const requestNewSubscription = async (): Promise<SubscriptionActionResponse> => {
  const { data } = await axiosInstance.post(ApiRoutes.PROFILE_SUBSCRIPTION_SUBSCRIBE, {});
  return data;
};
